"use client";

import type { ReactNode } from "react";
import {
  CurrencyPricesContext,
  type CurrencyPrices,
} from "@/hooks/useCurrencyPrices";

interface CurrencyPricesProviderProps {
  children: ReactNode;
  prices: CurrencyPrices;
}

export default function CurrencyPricesProvider({
  children,
  prices,
}: CurrencyPricesProviderProps): React.JSX.Element {
  return (
    <CurrencyPricesContext.Provider value={prices}>
      {children}
    </CurrencyPricesContext.Provider>
  );
}
